<template>
  <div class="cb-wrap">
      <!-- single section -->
    <div class="cb-single-screen">
      <template v-if="one_screen_checkout">
        <payment-section :subscribe-mode="true">
          <!-- coupon section -->
          <!-- TODO dry coupon code -->
          <div class="cb-section" v-if="coupon_enabled && !is_discount_present">
            <cb-discount :center-align="'true'"></cb-discount>
          </div>
        </payment-section>
      </template>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'

import PaymentSection from "@/components/modules/checkout/PaymentSection"
import Discount from "@/components/modules/hosted-pages/DiscountComponent"
import Notes from "@/components/collections/elements/Notes"

export default {
   components: {
      'payment-section': PaymentSection,
      'cb-discount': Discount,
      'cb-notes': Notes
    },
    computed: {
      ...mapGetters(
          [
              "one_screen_checkout",
              "is_discount_present",
              "coupon_enabled",
              "hasTrialPeriod",
              "selected_payment_method",
              "payment_option"
          ]
      ),
    }
}
</script>



// WEBPACK FOOTER //
// OneScreenReview.vue?068c5114